module.exports = __webpack_public_path__ + "static/media/illu_profil-edited.e35d6b46.svg";